import { createTheme } from "@mui/material";

import { palette } from './palette';
import { typography } from './typography';
import { components } from './components';

declare module '@mui/material/styles' {
    interface Palette {
        ink: Palette['primary'];
        navy: Palette['primary'];
        fog: string;
        lineOnDark: string;
    }

    interface PaletteOptions {
        ink?: PaletteOptions['primary'];
        navy?: PaletteOptions['primary'];
        fog?: string;
        lineOnDark?: string;
    }

    interface TypographyVariants {
        display1: React.CSSProperties;
        display2: React.CSSProperties;
    }

    interface TypographyVariantsOptions {
        display1?: React.CSSProperties;
        display2?: React.CSSProperties;
    }
}

declare module '@mui/material/Typography' {
    interface TypographyPropsVariantOverrides {
        display1: true;
        display2: true;
    }
}

export const theme = createTheme({
    palette,
    typography,
    components,
});
